import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import IQMCard from './components/IQMCard';
import MessageBox from 'components/MessageBox';
import ListView from 'components/ListView';
import { requestIQMList } from 'actionCreators';
import ui from 'redux-ui';
import IQMType from 'types/iqm';
import { getRole,
  getIqmsHasNextPage,
  getIqmsLoading,
  getIqmsList,
} from '../../../../reducers';

class IQMList extends Component {
  static propTypes = {
    ui: PropTypes.shape({
      successMessage: PropTypes.string,
    }),
    updateUI: PropTypes.func.isRequired,
    needsMore: PropTypes.bool,
    loading: PropTypes.bool,
    iqms: PropTypes.arrayOf(IQMType).isRequired,
    role: PropTypes.string,
    requestIQMList: PropTypes.func.isRequired,
  }

  componentDidMount() {
    this.props.requestIQMList();
  }

  componentWillUnmount() {
    if (this.props.ui.successMessage) {
      this.props.updateUI('successMessage', '');
    }
  }

  handleInfiniteLoad = () => (
    this.props.needsMore && !this.props.loading ? this.props.requestIQMList() : null
  );

  render() {
    const { iqms, role, needsMore, loading } = this.props;

    return (
      <div>
        {this.props.ui.successMessage
          ? <MessageBox message={this.props.ui.successMessage} />
          : null
        }
        <ListView
          loading={loading}
          needsMore={needsMore}
          handleInfiniteLoad={this.handleInfiniteLoad}
        >
          {iqms.map(iqm =>
            <IQMCard
              key={`iqm-${iqm.id}`}
              role={role}
              iqm={iqm}
            />,
          )}
        </ListView>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  iqms: getIqmsList(state),
  needsMore: getIqmsHasNextPage(state),
  loading: getIqmsLoading(state),
  role: getRole(state),
});

export default ui()(connect(
  mapStateToProps, { requestIQMList },
)(IQMList));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/iqms/IQMList.jsx